import { createLabeledMessages, join } from '../../../messageUtils';
const agent = {
    agent: 'agent',
    mainAgent: join('Main', 'agent:agent'),
    secondaryAgent: join('Secondary', 'agent:agent'),
    agentNumber: 'agent number',
    agentNumber_short: 'AČ',
    cnb: 'registration number ČNB',
    cnb_short: 'ČNB'
};
export default Object.assign({}, agent, createLabeledMessages(agent));
